namespace Solovis.Reports.Parts.Tables.DataTableHelpers {

    var edgeWidth = 10;
    var isOnResizeHandle = function (th, event) {
        var jTh = $(th);
        var width = jTh.outerWidth();
        var left = jTh.offset().left;
        var rightEdge = left + width;

        if (event.pageX > (rightEdge - edgeWidth)) {
            return true;
        }

        return false;
    }

    var addResizeLayer = function (cursor) {
        var layer = $("<div>")
            .css("position", "fixed")
            .css("left", "0")
            .css("top", "0")
            .css("width", "100%")
            .css("height", "100%")
            .css("background-color", "transparent")
            .css("cursor", cursor);

        var zIndex = Solovis.UI.DomHelper.findMaxZIndexForElementChildren(document.body);
        layer.css("z-index", zIndex + 1);

        layer.appendTo(document.body);

        return layer;
    };


    export class VisualColumnResizer {

        public tableControl: Solovis.Reports.Parts.Tables.DataTableControl;

        constructor(options) {
            this.tableControl = options.tableControl;
        }

        public static addResizeHandler(headerCell, tableControl) {
            var jHeaderCell = $(headerCell);
            var headerCellElement: any = jHeaderCell.get(0);
            var dataTableColumnId = headerCellElement.__dataTableColumnId;

            jHeaderCell.mousemove(function (e) {
                var th = this;
                if (isOnResizeHandle(this, e) || th.__mousemoveResizeCallback) {
                    jHeaderCell.css("cursor", "e-resize");
                }
                else {
                    jHeaderCell.css("cursor", "");
                }
            });

            jHeaderCell.mouseout(function (e) {
                jHeaderCell.css("cursor", "");
            });

            var tableHeaderRow = jHeaderCell.parent();
            var tableHeader = tableHeaderRow.parent();
            var table: any = tableHeader.parent();
            if (table.get(0).nodeName != "TABLE") {
                console.log("table not found");
                throw "Table not found.";
            }

            // If we have a floating header, the true table will be chained off of the floating table header.
            var trueTable = table;
            if (table.get(0).__floatingColumnHeaderTrueTableGetter) {
                var trueTableElement = table.get(0).__floatingColumnHeaderTrueTableGetter();
                trueTable = $(trueTableElement);
            }

            var colgroup = table.children("colgroup");
            if (colgroup.length == 0) {
                console.log("colgroup not found");
                throw "colgroup not found.";
            }

            var trueColgroup = trueTable.children("colgroup");
            if (trueColgroup.length == 0) {
                console.log("trueColgroup not found");
                throw "trueColgroup not found.";
            }

            jHeaderCell.mousedown(function (e) {
                var th = this;
                if (isOnResizeHandle(this, e)) {

                    th.__resizeLayer = addResizeLayer("e-resize");

                    var forceRedraw = function (element) {
                        var scrollLeft = $(window).scrollLeft();
                        var scrollTop = $(window).scrollTop();

                        var disp = element.style.display;
                        element.style.display = 'none';
                        var trick = element.offsetHeight;
                        element.style.display = disp;

                        $(window).scrollLeft(scrollLeft);
                        $(window).scrollTop(scrollTop);
                    };

                    var resizeOverlay = new VisualColumnResizer.ResizeOverlay();

                    var handleResizeCallback = function (newWidth) {
                        // Determine new size.
                        var currentWidth = $(th).outerWidth();

                        // Preserve scrollLeft on the parent scroll container.
                        var trueTableContainer = trueTable.parent();
                        var trueTableContainerScrollLeft = trueTableContainer.scrollLeft();

                        // Update the width on column mods.
                        var columnObj = tableControl.columnSet.getColumnById(dataTableColumnId);
                        if (columnObj) {
                            var colMods = columnObj.mods;
                            if (!colMods) {
                                colMods = {};
                            }
                            colMods.width = newWidth;
                            columnObj.updateMods(colMods, true /* suppressColumnChangeEvent */);
                        }

                        // Apply resize
                        var tableWidth = $(trueTable).outerWidth();

                        var trueTableHeaderRow = trueTable.children("thead").children("tr").last();

                        var totalWidth = 0;
                        var colgroupColList = trueColgroup.children("col");
                        var thList = trueTableHeaderRow.children("th");
                        var thWidths = [];
                        $(thList).each(function (i, otherTh: any) {
                            var width;
                            var col = colgroupColList.get(i);
                            if (otherTh.__dataTableColumnId !== th.__dataTableColumnId) {
                                if (col.style.width) {
                                    var widthStr = col.style.width;
                                    if (widthStr.indexOf("px") >= 0) {
                                        width = parseInt(widthStr);
                                    }
                                }
                                if (!width) {
                                    width = $(otherTh).outerWidth();
                                }
                            }
                            else {
                                width = newWidth;
                            }

                            thWidths.push(width);
                            totalWidth += width;
                        });

                        var tableMods = tableControl._tableMods;
                        var tableSettingsToUse = tableControl._tableSettingsToUse;
                        var fitToScreen = tableSettingsToUse.fitToScreen;

                        if (fitToScreen) {
                          tableMods.fitToScreen = false;
                          tableControl.updateTableMods(tableMods);
                        }

                        $(trueTable).css("width", "" + totalWidth + "px");
                        $(colgroupColList).each(function (i, col) {
                            var newWidth = thWidths[i];
                            $(col).css("width", "" + newWidth + "px");
                        });

                        // NOTE: This is a "hack" to workaround a bug in Chrome, where Chrome will not render the table correctly immediately
                        // after resizing a column.
                        forceRedraw(trueTable.get(0));

                        trueTableContainer.scrollLeft(trueTableContainerScrollLeft);

                        if (trueTableContainer.get(0).__solovisPostColumnResizeCallback) {
                            trueTableContainer.get(0).__solovisPostColumnResizeCallback();
                        }
                    };

                    var mousemoveCallback = function (e) {
                        // Suppress text selection while dragging mouse.
                        if ((document as any).selection) {
                            (document as any).selection.empty();
                        }
                        else if (window.getSelection) {
                            window.getSelection().removeAllRanges();
                        }

                        resizeOverlay.show(table, th, e.pageX);

                        e.preventDefault();
                        e.stopPropagation();
                    };

                    th.__mousemoveResizeCallback = mousemoveCallback;

                    th.__mouseupResizeCallback = function (e) {
                        resizeOverlay.destroy();

                        var thNewWidth = Math.max(20, (e.pageX - th.__resizeStartX) + th.__resizeStartWidth);
                        handleResizeCallback(thNewWidth);

                        $(window).unbind("mousemove", th.__mousemoveResizeCallback);
                        $(window).unbind("mouseup", th.__mouseupResizeCallback);

                        if (th.__resizeLayer) {
                            $(th.__resizeLayer).remove();
                            delete th.__resizeLayer;
                        }

                        $(th).css("cursor", "");

                        delete th.__mousemoveResizeCallback;
                        delete th.__mouseupResizeCallback;
                        delete th.__resizeStartX;
                        delete th.__resizeStartWidth;

                        e.preventDefault();
                        e.stopPropagation();
                    };

                    $(window).bind("mousemove", th.__mousemoveResizeCallback);
                    $(window).bind("mouseup", th.__mouseupResizeCallback);
                    th.__resizeStartX = e.pageX;
                    th.__resizeStartWidth = $(th).outerWidth();

                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        };   

    }

}

    
namespace Solovis.Reports.Parts.Tables.DataTableHelpers.VisualColumnResizer {

    export class ResizeOverlay {

        public _placementDiv;
        
        constructor() {
        }


        public show(table, th, newX) {
            if (!this._placementDiv) {
                this._placementDiv = $("<div>").css("position", "absolute").css("z-index", 50000).css("cursor", "e-resize")
                    .css("height", "32px").css("width", "3px").css("background-color", "#00f");
                this._placementDiv.appendTo(document.body);
            }

            var tableOffset = $(table).offset();
            var tableHeight = $(table).height();

            var thOffset = $(th).offset();

            var placeholderHeight = tableHeight - (thOffset.top - tableOffset.top);

            this._placementDiv.css("left", "" + newX + "px");
            this._placementDiv.css("top", "" + thOffset.top + "px");
            this._placementDiv.css("height", "" + placeholderHeight + "px");
        }

        public destroy() {
            if (this._placementDiv) {
                this._placementDiv.remove();
                this._placementDiv = null;
            }
        }
    }

}
    